import { useEffect } from 'react'
// next
import { useRouter } from 'next/router'
// config
import useAuth from 'hooks/useAuth'

export default function HomePage() {
  const { pathname, replace, prefetch } = useRouter()
  const { targetRedirectUrl } = useAuth()

  useEffect(() => {
    if (pathname === '/') {
      replace(targetRedirectUrl)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])

  useEffect(() => {
    prefetch(targetRedirectUrl)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}
